"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.MenuItem = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const layout_1 = require("../modules/layout");
const react_native_1 = require("react-native");
function MenuItem(props) {
    const theme = (0, theme_1.getTheme)();
    const styles = react_native_1.StyleSheet.create({
        container: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            paddingRight: 10
        },
        text: {
            color: theme.textColor1,
            fontFamily: theme.fontFamily1,
            fontSize: (0, layout_1.isTablet)() ? 20 : 16,
            paddingVertical: (0, layout_1.isTablet)() ? 15 : 14
        },
        textDisabled: {
            color: theme.borderColor1
        },
        textSelected: {
            color: theme.textColor2
        },
        subText: {
            fontSize: 12,
            marginLeft: 5
        },
        icon: {
            paddingTop: 12,
            paddingRight: 10,
            color: theme.textColor1
        }
    });
    const { menuItem, icon, textStyle, onPress, isCurrentMenuPath } = props;
    const selected = isCurrentMenuPath != undefined &&
        menuItem.path != undefined &&
        isCurrentMenuPath(menuItem.path);
    return (React.createElement(react_native_1.TouchableOpacity, { disabled: menuItem.disabled, style: styles.container, onPress: onPress },
        React.createElement(react_native_1.Text, { nativeID: menuItem.nativeID, testID: (0, test_1.getTestID)(menuItem.nativeID), style: [
                styles.text,
                menuItem.disabled && styles.textDisabled,
                selected && styles.textSelected,
                textStyle,
                menuItem.textStyle
            ] },
            menuItem.text,
            menuItem.subText && (React.createElement(react_native_1.Text, { style: [styles.subText, menuItem.subTextStyle] }, menuItem.subText))),
        icon && React.createElement(FontAwesome_1.default, { name: icon, style: styles.icon, size: 20 })));
}
exports.MenuItem = MenuItem;
class Menu extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            indexMenuOpened: -1
        };
        this.handleParentMenuPress = (index) => {
            this.setState({
                indexMenuOpened: this.state.indexMenuOpened === index ? -1 : index
            });
        };
        this.handleMenuPress = (path) => {
            if (path != undefined) {
                this.props.onMenuPress(path);
            }
        };
        this.getStyles = () => {
            const styles = react_native_1.StyleSheet.create({
                submenuText: {
                    paddingLeft: 20,
                    paddingVertical: (0, layout_1.isTablet)() ? 10 : 8
                }
            });
            return styles;
        };
    }
    componentDidMount() {
        const { menu, isCurrentMenuPath } = this.props;
        const indexMenuOpened = menu.findIndex(menuItem => menuItem.submenu != undefined &&
            menuItem.submenu.some(submenuItem => isCurrentMenuPath != undefined &&
                submenuItem.path != undefined &&
                isCurrentMenuPath(submenuItem.path)));
        this.setState({ indexMenuOpened });
    }
    render() {
        const { menu, isCurrentMenuPath } = this.props;
        const styles = this.getStyles();
        return (React.createElement(React.Fragment, null, menu.map((menuItem, menuItemIndex) => {
            const menuItemIsOpen = this.state.indexMenuOpened === menuItemIndex;
            const menuItemIcon = menuItem.submenu
                ? menuItemIsOpen
                    ? 'caret-up'
                    : 'caret-down'
                : undefined;
            const menuItemOnPress = () => menuItem.submenu
                ? this.handleParentMenuPress(menuItemIndex)
                : this.handleMenuPress(menuItem.path);
            return (React.createElement(react_native_1.View, { key: menuItemIndex },
                React.createElement(MenuItem, { menuItem: menuItem, icon: menuItemIcon, onPress: menuItemOnPress, isCurrentMenuPath: isCurrentMenuPath }),
                menuItem.submenu && (React.createElement(react_native_1.View, { style: {
                        height: menuItemIsOpen ? 'auto' : 0,
                        overflow: 'hidden'
                    } }, menuItem.submenu.map((submenuItem, submenuItemIndex) => (React.createElement(MenuItem, { key: submenuItemIndex, menuItem: submenuItem, textStyle: styles.submenuText, onPress: () => this.handleMenuPress(submenuItem.path), isCurrentMenuPath: isCurrentMenuPath })))))));
        })));
    }
}
exports.Menu = Menu;
